import React from "react"

import { Row, Col, Form, Button } from "react-bootstrap"

const MultiType = props => {
  const { values, setCic, nextStep } = props
  

  const setCicAndNext = cic => {
    setCic(cic)
    nextStep()
  }

  return (
    <div style={{ textAlign: "center" }}>
      {/* <---------------Q1--------------->*/}
      <Row style={{ justifyContent: "center" }}>
        <Col xs={12} sm={6}>
          <Form.Label className="button-question">
            Critical illness cover?
          </Form.Label>

          {/* <---------------BUTTON--------------->*/}
          <Row>
            <Col
              sm={4}
              xs={{ offset: 2, span: 4 }}
              style={{ textAlign: "center" }}
            >
              <div>
                <Button
                  // type="button"
                  className="orange-btn"
                  onClick={() => setCicAndNext(true)}
                  active={values.cic === true ? true : null}
                >
                  <i className="fas fa-thumbs-up fa-2x"></i>
                </Button>
              </div>
              <Form.Label className="button-label">Yes</Form.Label>
            </Col>
            {/* <---------------BUTTON--------------->*/}
            <Col sm={4} xs={4} style={{ textAlign: "center" }}>
              <div>
                <Button
                  // type="button"
                  className="orange-btn"
                  onClick={() => setCicAndNext(false)}
                  active={values.cic === false ? true : null}
                >
                  <i className="fas fa-thumbs-down fa-2x"></i>
                </Button>
              </div>
              <Form.Label className="button-label">No</Form.Label>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default MultiType
